export default [
  {
    path: '/userpays',
    name: 'userpays',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Оплаты',
    },
    children: [
      {
        path: '',
        name: 'userpays-list',
        component: () => import('@/views/userpays/userpays.vue'),
        meta: {},
      },
      {
        path: 'add',
        name: 'userpays-add',
        component: () => import('@/views/userpays/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
    ],
  },
]
